import { context } from "../services";
import { sagaMiddleware } from "../store/setup";
import rootSaga from ".";

sagaMiddleware.run(rootSaga, context);
